var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as ErrorCode from './ErrorCode';
import { USER_TOKEN, USER_DATA, USER_INFO_KEY, PUBLISHERS_KEY, CURRENT_MEDIA, CURRENT_MENU_ITEM } from './LocalStorageUtil';
import { WD_SUMARY_CACHE_KEY, WD_TOP3_INCREASE_CACHE_KEY, WD_TOP3_DECREASE_CACHE_KEY } from './StorageKeys';
import { syncUserIdToDataLayer } from './analytics';
export var handleResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (response && response.data && response.data.status == 'failed') {
            return [2 /*return*/, Promise.reject(response.data)];
        }
        else if (response.data.status == 'succeeded') {
            return [2 /*return*/, Promise.resolve(response.data.data)];
        }
        return [2 /*return*/];
    });
}); };
export var handleUnauthorizedError = function (error) {
    if (error && error.response && error.response.data) {
        var errorCode = error.response.data.code;
        console.log('error.response:', error.response);
        console.log('error.response.data:', error.response.data);
        if (errorCode === ErrorCode.ERROR_BAD_TOKEN) {
            localStorage.removeItem(USER_INFO_KEY);
            localStorage.removeItem(PUBLISHERS_KEY);
            localStorage.removeItem(CURRENT_MEDIA);
            localStorage.removeItem(USER_TOKEN);
            localStorage.removeItem(USER_DATA);
            localStorage.removeItem(WD_SUMARY_CACHE_KEY);
            localStorage.removeItem(CURRENT_MENU_ITEM);
            localStorage.removeItem(WD_TOP3_INCREASE_CACHE_KEY);
            localStorage.removeItem(WD_TOP3_DECREASE_CACHE_KEY);
            syncUserIdToDataLayer();
            redirectToLogin();
        }
    }
};
export var redirectToLogin = function () {
    var loginUrl = window.location.origin + '/#/login';
    console.log('origin:', window.location.origin);
    console.log('loginUrl:', loginUrl);
    window.location.replace(loginUrl);
    // window.location.replace(origin + '/new/#/login');
};
